import { FormikHelpers } from "formik";
import { useCreateModel } from "./api/createModel";
import ModelForm from "./ModelForm";


const CreateModel = ({handleCloseModal}: CreateModelProps)  => {
  const createModelMutation = useCreateModel({data: {}});

  const initialValues: ICreateModelForm = {
    description: "",
    deleted: false,
    modelTypeID: "",
    module: false
  };

  const handleSubmit = async (values: ICreateModelForm, { setSubmitting }: FormikHelpers<ICreateModelForm>): Promise<void> => {
    try {
      await createModelMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <ModelForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateModelProps {
  handleCloseModal: () => void;
}

export default CreateModel;